"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDialog = void 0;

var _react = _interopRequireDefault(require("react"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _ErrorDialogActions = require("./components/ErrorDialogActions");

var _ErrorDialogStyled = require("./ErrorDialogStyled");

var _OverflowContainer = require("../OverflowContainer");

/**
 * @name ErrorDialog
 * @description Component which renders a dialog to display errors.
 * @param {Object} Props - ErrorDialog parameter object
 * @param {string} Props.title - Title of Error dialog.
 * @param {string} Props.message - Text message for Error dialog.
 * @param {string} Props.actionTitle - Action title of Error dialog.
 * @param {boolean} Props.isOpen - Error dialog visibility state.
 * @param {function} Props.closeModal - Callback function which closes modal.
 * @returns {JSX.Element|null}
 * @memberof privacy-shared-react
 */
var ErrorDialog = function ErrorDialog(_ref) {
  var message = _ref.message,
      title = _ref.title,
      actionTitle = _ref.actionTitle,
      isOpen = _ref.isOpen,
      closeModal = _ref.closeModal;
  return /*#__PURE__*/_react.default.createElement(_OverflowContainer.OverflowContainer, {
    shouldBlockScroll: isOpen
  }, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.DialogStyled, {
    title: title,
    isOpen: isOpen,
    closeModal: closeModal,
    classes: {
      backdropContainer: 'error-dialog-container',
      closeButton: 'dialog-close-button',
      header: 'error-dialog-header',
      content: 'error-dialog-content'
    },
    slots: {
      FooterSlot: /*#__PURE__*/_react.default.createElement(_ErrorDialogActions.ErrorDialogActions, {
        actionTitle: actionTitle,
        closeModal: closeModal
      })
    },
    components: {
      DialogBaseComp: _ErrorDialogStyled.ErrorDialogStyled
    },
    dialogContainerCompProps: {
      'data-testid': 'error-dialog'
    },
    backdropCompProps: {
      style: {
        // The error modal should overlap geo-mismatch modal window when it is loaded
        zIndex: '2100'
      },
      'data-testid': 'dialog-backdrop'
    }
  }, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.TextStyled, {
    "data-testid": "error-dialog-message",
    appearance: "body2"
  }, message)));
};

exports.ErrorDialog = ErrorDialog;